import ApiRequest from './apiRequest';

class ProjectsService {
  static async getPgeProjects(size, page, sort, filters, archived) {
    const data = await ApiRequest.apiRequest(
      {
        method: 'POST',
        url: `pge/fetch?size=${size}&page=${page}&property=${sort.sortField}&sort=${sort.order}`,
        body: {...filters, isArchived: archived}
      }
    );
    return data;
  };

  static async exportPgeProjects(size, page, sort, filters, archived) {
    const data = await ApiRequest.apiRequest(
      {
        method: 'POST',
        url: `pge/export?size=${size}&page=${page}&property=${sort.sortField}&sort=${sort.order}`,
        body: {...filters, isArchived: archived},
        responseType: 'blob',
        fileName: `export_pge_${(new Date()).toLocaleDateString()}.xlsx`
      }
    );
    return data;
  };

  static async getSinglePgeProject(id) {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `pge/${id}`, addVersion: true}
    );
    return data;
  };

  static async addPgeProject(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `pge`, body: payload, noResponse: true}
    );
    return data;
  };

  static async updatePgeProject(payload, projectId, version) {
    const data = await ApiRequest.apiRequest(
      {method: 'PUT', url: `pge/${projectId}`, body: payload, noResponse: true, version: version}
    );
    return data;
  };

  static async deletePgeProject(projectId) {
    const data = await ApiRequest.apiRequest(
      {method: 'DELETE', url: `pge/${projectId}`, noResponse: true}
    );
    return data;
  };

  static async updateSingleFieldInPgeProject(payload, projectId, version) {
    const data = await ApiRequest.apiRequest(
      {method: 'PATCH', url: `pge/${projectId}`, body: payload, noResponse: true, version: version}
    );
    return data;
  };

  static async updatePgeProjectState(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `pge/workflow`, body: payload, noResponse: true}
    );
    return data;
  };

  static async getStoenProjects(size, page, sort, filters, archived) {
    const data = await ApiRequest.apiRequest(
      {
        method: 'POST',
        url: `stoen/fetch?size=${size}&page=${page}&property=${sort.sortField}&sort=${sort.order}`,
        body: {...filters, isArchived: archived}
      }
    );
    return data;
  };

  static async exportStoenProjects(size, page, sort, filters, archived) {
    const data = await ApiRequest.apiRequest(
      {
        method: 'POST',
        url: `stoen/export?size=${size}&page=${page}&property=${sort.sortField}&sort=${sort.order}`,
        body: {...filters, isArchived: archived},
        responseType: 'blob',
        fileName: `export_stoen_${(new Date()).toLocaleDateString()}.xlsx`
      }
    );
    return data;
  };

  static async getSingleStoenProject(id) {
    const data = await ApiRequest.apiRequest(
      {method: 'GET', url: `stoen/${id}`, addVersion: true}
    );
    return data;
  };

  static async addStoenProject(payload) {

    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `stoen`, body: payload, noResponse: true}
    );
    return data;
  };

  static async updateStoenProject(payload, projectId, version) {
    const data = await ApiRequest.apiRequest(
      {method: 'PUT', url: `stoen/${projectId}`, body: payload, noResponse: true, version: version}
    );
    return data;
  };

  static async deleteStoenProject(projectId) {
    const data = await ApiRequest.apiRequest(
      {method: 'DELETE', url: `stoen/${projectId}`, noResponse: true}
    );
    return data;
  };

  static async updateSingleFieldInStoenProject(payload, projectId, version) {
    const data = await ApiRequest.apiRequest(
      {method: 'PATCH', url: `stoen/${projectId}`, body: payload, noResponse: true, version: version}
    );
    return data;
  };

  static async updateStoenProjectState(payload) {
    const data = await ApiRequest.apiRequest(
      {method: 'POST', url: `stoen/workflow`, body: payload, noResponse: true}
    );
    return data;
  };
}

export default ProjectsService;
